import httpService from "../_utils/http-service";
import { getAuthHttpConfig } from "../_utils/auth-utils";
import { traceEvent } from "../_utils/analytics-utils";

export const fetchCustomerReferralRewards = (customerId, orderId, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;
    httpService
      .get(
        `customers/${customerId}/order/${orderId}/hasReferralRewards`,
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({ success: true, referralRewards: res.data.data });
        } else {
          callback({ success: false });
          traceEvent("error", "fetchCustomerReferralRewards");
        }
      })
      .catch(err => {
        traceEvent("error", "fetchCustomerReferralRewards");
        callback({ success: false });
      });
  };
};
